export const FPS = 60;
export const IS_DEBUG = false;

export const BREAK_WIDTH_PC = 768;

export const GALLERY_QTY_PC = 12;

export const GALLERY_QTY_SP = 12;
